import React, { useState } from "react";
import PropTypes from "prop-types";

import "./NestedDropDown.css"; // Import the CSS file for styling

NestedDropDown.propTypes = {
  items: PropTypes.array,
  width: PropTypes.string,
  label: PropTypes.string,
  onSelect: PropTypes.func,
};

export function NestedDropDown(props) {
  const { items, onSelect } = props;
  const { width } = props;
  const { label } = props;

  // State to track whether the main dropdown is open or closed
  const [open, setOpen] = useState(false);

  // State to track the currently selected item
  const [selected, setSelected] = useState("");

  // State to manage which submenu is open at each level
  const [dropdownOpen, setDropdownOpen] = useState({});

  return (
    <div className="nested-dropdown" style={{ width: width }}>
      {/* Main dropdown toggle button */}
      <button
        id={"nested-drop-down-toggle-button"}
        onClick={() => setOpen(!open)}
        className="nested-dropdown-toggle"
        style={{ width: width }}
        aria-expanded={open} // Accessibility: Indicates if the dropdown is expanded
      >
        <div>{selected || "Select " + label}</div>
        <div>{"▼"}</div>
        {/* Show selected item or placeholder */}
      </button>

      {/* Dropdown menu */}
      {open && (
        <div className="nested-dropdown-menu">
          {renderItems(
            items,
            dropdownOpen,
            setDropdownOpen,
            setSelected,
            setOpen,
            onSelect
          )}
        </div>
      )}
    </div>
  );
}

function renderItems(
  items,
  dropdownOpen,
  setDropdownOpen,
  setSelected,
  setOpen,
  onSelect,
  level = 0
) {
  const display = [];

  items.forEach((item, index) =>
    display.push(
      <li key={item.id} className="nested-dropdown-item">
        {/* Handle click to toggle submenu or select the item */}
        <button
          id={"nested-dropdown-item-button-" + item.id}
          onClick={() =>
            item.options.length
              ? toggleDropdown(level, index, dropdownOpen, setDropdownOpen)
              : handleSelect(item, setSelected, setOpen, onSelect)
          }
          className={`nested-dropdown-link ${
            dropdownOpen[level] === index ? "open" : ""
          }`}
          aria-expanded={dropdownOpen[level] === index} // Accessibility: Indicates if submenu is expanded
        >
          {/* Render the item's value */}
          <span>{item.value}</span>

          {/* Render the arrow for items with options */}
          {item.options.length > 0 && (
            <span className="nested-dropdown-arrow">
              {dropdownOpen[level] === index ? "▼" : "▶"}
            </span>
          )}
        </button>

        {/* Render the nested submenu if the item is open and has options */}
        {dropdownOpen[level] === index && item.options.length > 0 && (
          <div className="nested-dropdown-submenu">
            {renderItems(
              item.options,
              dropdownOpen,
              setDropdownOpen,
              setSelected,
              setOpen,
              onSelect,
              level + 1
            )}
          </div>
        )}
      </li>
    )
  );

  return <ul className="nested-dropdown-list">{display}</ul>;
}

function toggleDropdown(level, index, dropdownOpen, setDropdownOpen) {
  setDropdownOpen((prev) => ({
    ...prev,
    [level]: prev[level] === index ? null : index, // Close submenu if already open, otherwise open it
  }));
}

function handleSelect(item, setSelected, setOpen, onSelect) {
  setSelected(item.value); // Update the selected item value
  setOpen(false); // Close the dropdown
  if (onSelect) onSelect(item.value); // Trigger the callback function with the selected item
}
